import { ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.state';
import MESSAGE from 'src/assets/resource/strings.json';

@Component({
  selector: 'app-followed-properties-group-card',
  templateUrl: './followed-properties-group-card.component.html',
  styleUrls: ['./followed-properties-group-card.component.scss'],
})
export class FollowedPropertiesGroupCardComponent implements OnInit {
  @Input() exportingInProgress: any;
  @Input() followGroupNameList: any;
  @Input() isExternalExportEnabled: any;
  @Input() isGroupNameChangeInProgress: any;
  @Input() isLoading: boolean = false;
  @Input() propertyGroup: any;
  @Input() disabled: boolean = false;

  @Output() deleteId = new EventEmitter<any>();
  @Output() editName = new EventEmitter<string>();
  @Output() exportData = new EventEmitter<any>();
  @Output() externalExportFile = new EventEmitter<any>();
  @Output() favoriteLoading = new EventEmitter<boolean>();
  @Output() updateName = new EventEmitter<any>();
  @Output() updateNameData = new EventEmitter<any>();

  @HostBinding('style.pointer-events') get pointerEvent() {
    return this.disabled ? 'none' : 'auto';
  }

  stringRes: any = MESSAGE;
  companyName = '';
  editGroupName: boolean = false;
  onDestroyNotifier$ = new Subject();
  followGroupDataSource: any;
  favGroupPageSize = 10;
  favGroupPageIndex = 0;
  favGroupOrderBy = 'id';
  favGroupOrderType = 'desc';
  showPropertyList: boolean;
  favGroupListCount: number = 0;
  spinnerStatus: boolean = false;

  i: any;

  constructor(private appState: AppState, private snackBar: MatSnackBar, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.appState.companyInfo$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
      if (res && res.isExternalExportEnabled) {
        this.isExternalExportEnabled = res.isExternalExportEnabled ? true : false;
        this.companyName = res.name;
      }
    });
  }
  cancelEditing() {
    this.editGroupName = false;
  }
  enableEditing(element) {
    this.editGroupName = true;

    this.editName.emit(element);
    this.cd.detectChanges();
  }
  deleteGroup(id, favCount) {
    let value = {
      id: id,
      favCount: favCount,
    };
    this.deleteId.emit(value);
  }

  readyToExport(group, id, name) {
    let exportDetails = {
      group: group,
      id: id,
      name: name,
    };
    this.exportData.emit(exportDetails);
  }
  externalExport(propertyGroup) {
    this.externalExportFile.emit(propertyGroup);
  }

  openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }
  updateGroupName(element, i) {
    let updateNameData = {
      element: element,
      i: i,
    };
    this.updateName.emit(updateNameData);
    if (this.propertyGroup.newName) {
      this.editGroupName = false;
    }
  }
}
